import {
  fetchServicePartnerCollectionById,
  updateServicePartnerCollectionById,
} from "@/lib/api/resources/servicePartnerCollections";
import { ServicePartnerCollectionFormData } from "@rumble-it/common-lib/types/models/ServicePartnerCollection.interface";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Col, Form, message, Row } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ServicePartnerCollectionFormCard } from "./components/ServicePartnerCollectionFormCard";
import { ServicePartnersCard } from "./components/ServicePartnersCard";

export const ServicePartnersCollectionEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form] = Form.useForm<ServicePartnerCollectionFormData>();

  if (!id) return null;

  const [selectedServicePartnerIds, setSelectedServicePartnerIds] = useState<
    string[]
  >([]);

  const servicePartnerCollectionQuery = useQuery({
    queryKey: ["service-partner-collections", id],
    queryFn: () => fetchServicePartnerCollectionById(id),
  });

  const updateServicePartnerCollectionMutation = useMutation({
    mutationFn: (data: ServicePartnerCollectionFormData) =>
      updateServicePartnerCollectionById(id, data),
    onSuccess: () => {
      navigate(`/service-partners/collections/${id}`);
      message.success("Subnetwerk succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van het subnetwerk",
      ),
  });

  useEffect(() => {
    if (servicePartnerCollectionQuery.data) {
      form.setFieldsValue({
        name: servicePartnerCollectionQuery.data.name,
        description: servicePartnerCollectionQuery.data.description,
      });
      setSelectedServicePartnerIds(
        servicePartnerCollectionQuery.data.servicePartners.map((sp) => sp.id),
      );
    }
  }, [form, servicePartnerCollectionQuery.data]);

  const handleFinish = (values: ServicePartnerCollectionFormData) => {
    updateServicePartnerCollectionMutation.mutate({
      ...values,
      servicePartners: selectedServicePartnerIds.length
        ? selectedServicePartnerIds
        : null,
    });
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical">
      <Row gutter={[16, 16]}>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnerCollectionFormCard
            title="Subnetwerk bewerken"
            buttonText="Bewerken"
            isLoading={servicePartnerCollectionQuery.isLoading}
            submitting={updateServicePartnerCollectionMutation.isPending}
          />
        </Col>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnersCard
            servicePartnerCollection={servicePartnerCollectionQuery.data}
            isLoading={servicePartnerCollectionQuery.isLoading}
            editMode
            selectedServicePartnerIds={selectedServicePartnerIds}
            setSelectedServicePartnerIds={setSelectedServicePartnerIds}
          />
        </Col>
      </Row>
    </Form>
  );
};
